module.exports = __webpack_public_path__ + "static/img/ad-ast.cc440334.gif";